/**
 * Tri « Manuel » (façon Todoist) : les tâches déjà déplacées à la main suivent l'ordre enregistré,
 * les autres gardent leur place dans le tri par échéance reçu.
 * Les tâches ordonnées se répartissent entre elles les places qu'elles occupent : une nouvelle tâche
 * s'insère donc à sa date sans bousculer l'ordre choisi.
 */
export function applyManualOrder<T extends { task_id: string }>(tasks: T[], orderedIds: string[]): T[] {
  if (!orderedIds.length) return tasks;
  const rank = new Map(orderedIds.map((id, index) => [id, index]));
  const ordered = tasks.filter((t) => rank.has(t.task_id)).sort((a, b) => rank.get(a.task_id)! - rank.get(b.task_id)!);
  let next = 0;
  return tasks.map((t) => (rank.has(t.task_id) ? ordered[next++] : t));
}

/** Ordre enregistré après un déplacement : celui de la section en tête, puis les autres tâches déjà connues */
export function mergeManualOrder(sectionIds: string[], previousIds: string[]): string[] {
  const inSection = new Set(sectionIds);
  return [...sectionIds, ...previousIds.filter((id) => !inSection.has(id))];
}
